import { BASE, authFetch, extractError, request } from "./client";

export interface AmbientSummary {
  id: string;
  display_name: string;
  duration_ms: number;
}

export interface AmbientListResponse {
  ambients: AmbientSummary[];
}

export function listAmbients(): Promise<AmbientListResponse> {
  return request("/ambients");
}

export function ambientPreviewUrl(id: string): string {
  return `${BASE}/ambients/${id}/preview`;
}

export async function adminUploadAmbient(
  file: File, displayName: string,
): Promise<{ id: string; duration_ms: number }> {
  const fd = new FormData();
  fd.append("audio", file, file.name);
  fd.append("display_name", displayName);
  const res = await authFetch("/admin/ambients", { method: "POST", body: fd });
  if (!res.ok) throw new Error(await extractError(res));
  return res.json();
}

export function adminDeleteAmbient(id: string): Promise<{ id: string }> {
  return request(`/admin/ambients/${id}`, { method: "DELETE" });
}
